//---------------------------\\
//--- Fonctions de scroll ---\\
//---------------------------\\

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Dans ce fichier on retrouve les fonctions utilisant le smooth scroll
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import $ from 'jquery'
import Scrollbar from 'smooth-scrollbar'
import { isMobile, isIE } from './helper.js'
//-----------------------------------------------------------------------------------------------------------------


// Fonction déterminant le type de scroll en desktop ou mobile
export function getScrollType() {
  if (!isMobile() && !isIE()) window.mainScrollbar = Scrollbar.init(document.querySelector('[data-mainScrollbar]'), { damping: 0.1 })
  else $('html').addClass('isMobile')
}


// Fonctions retournant l'événement de scroll à donner si le smoothscroll est activé ou pas
export function setScrollEvent(myFunction) {
  if(Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) window.mainScrollbar.addListener(myFunction)
  else $(window).on('scroll', myFunction)
}


// Donne la position de la scrollbar selon son type
export function getScrollTop() {
  
  if(Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) return window.mainScrollbar.scrollTop
  else return $(window).scrollTop()
}


// Fonction ajoutant tous les éléments fixed à l'écran
export function addFixedElements() {
  window.parallax.update()
  window.scrollfire.update()
  fixedFastLinkBtn()
  setScrollEvent(displayFixedFastLinksBtn)

  if(window.activeView == 'rubric' || window.activeView == 'documents' || window.activeView == 'newsDetail' || window.activeView == 'jobs' || window.activeView == 'job' || window.activeView == 'events' || window.activeView == 'event') {
    stickyNav()
    setScrollEvent(activateStickyNav)
  }
}


// Fonction retirant tous les éléments fixed à l'écran
export function removeFixedElements() {
  fixedFastLinkBtn(true)
  
  if(window.activeView == 'rubric' || window.activeView == 'documents' || window.activeView == 'newsDetail' || window.activeView == 'jobs' || window.activeView == 'job' || window.activeView == 'events' || window.activeView == 'event') {
    stickyNav(true)
  }
}



// -----------------------------------------------------------------------------------------

// Bouton des liens rapides fixed
function fixedFastLinkBtn( remove = false ) {
  var fixed = document.querySelector('.btnFastLinks')
  
  if(getScrollTop() > 300 || $('html').hasClass('showOverlayFastLinks')) {
    fixed.classList.add('display')
  } else {
    fixed.classList.remove('display')
  }

  if(!remove && Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) {
    var customOffset = 35
    var setOffset = () => {
      fixed.style.top = window.mainScrollbar.offset.y + customOffset +'px'
      fixed.style.right = customOffset + 'px'
    }
    $(window).on('resize', () => {
      setOffset()
    })
    setOffset()

    window.mainScrollbar.addListener(function(status) {
      fixed.style.top = status.offset.y + customOffset +'px'
      fixed.style.right = customOffset + 'px'
    })
  } else {
    fixed.style.top = ''
    fixed.style.right = ''
  } 
}


// Permet d'afficher ou de cacher les liens rapides
function displayFixedFastLinksBtn() {
  var fixed = document.querySelector('.btnFastLinks')
  
  if(getScrollTop() > 300 || $('html').hasClass('showOverlayFastLinks')) {
    fixed.classList.add('display')
  } else {
    fixed.classList.remove('display')
  }
}


// Permet de remettre le sticky nav au bon endroit 
function stickyNav(remove = false) {
  var sticky = document.querySelector('#stickyElements')

  if(!remove && Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) {
    if( $('#stickyNav').offset().top <= 0 ) {
      sticky.style.top = window.mainScrollbar.offset.y +'px'
    }
  } else {
    sticky.style.top = ''
  } 
}


// Permet de faire fonctionner le sticky nav
function activateStickyNav() {
  if(Scrollbar.has(document.querySelector('[data-mainScrollbar]'))) {
    if( $('#stickyNav').offset().top <= 0 ) {
      window.mainScrollbar.addListener(function(status) {
        document.querySelector('#stickyElements').style.top = status.offset.y +'px'
      })
    }
  }
} 